import Button from "../Button/Button";
import { useStore } from "./UserContext";
import * as utils from "../../utils/utils";
import { useEffect, useState } from "react";
import { humanFormatDateWithDay } from "../../utils/utils";
import { useNavigate } from "react-router-dom";

function AccountBanner() {
  const { store } = useStore();
  const [userDetails, setUserDetails] = useState<any>();
  const navigate = useNavigate();
  const [error, setError] = useState<any>(null);

  const hide = false;

  useEffect(() => {
    if (hide) {
      return;
    }
    getStatus();
  }, [store]);

  async function getStatus() {
    await getUserStatus();
    // if (utils.isUserAccountAdmin(store)) {
    //   await getAccountStatus();
    // }
  }

  // async function getAccountStatus() {
  //   const result: any = await utils.request(
  //     store,
  //     `invoices/status/${utils.user(store)?.id}`,
  //     "GET",
  //     {}
  //   );
  //   if (result.ok) {
  //     setInvoice(result?.data);
  //     const invoice = result?.data;
  //     if (invoice?.account_status === "on_hold") {
  //       navigate("/account-on-hold?status=on_hold");
  //       return;
  //     }
  //   }
  // }
  const ENTERPRISE_PLUS_ONBOARDING_STATUSES = [
    "awaiting_review",
    "submitted",
    "under_review",
    "agreed",
    "awaiting_payment",
    "rejected"
  ];

  async function getUserStatus() {
    const currentUser = utils.user(store);

    setUserDetails(currentUser);

    if (ENTERPRISE_PLUS_ONBOARDING_STATUSES.includes(currentUser?.status)) {
      if (window.location.pathname !== "/enterprise-onboarding") {
        navigate("/enterprise-onboarding");
      }
      return;
    }
    if (currentUser.status === "pending_plan_payment") {
      navigate("/account-on-hold");
      return;
    }
    if (currentUser.status === "suspended") {
      navigate("/account-on-hold?status=suspended");
      return;
    }
    if (currentUser.status === "archived") {
      navigate("/account-on-hold?status=archived");
      return;
    }
    if (
      currentUser?.role_id !== 5 &&
      (currentUser?.account_status === "on_hold" || currentUser?.status === "on_hold")
    ) {
      navigate("/account-on-hold?status=on_hold");
      return;
    }
    // A finished trial is as blocked as an unpaid account, so it lands on the
    // same screen — which asks for the subscription rather than a late payment.
    if (currentUser?.role_id !== 5 && currentUser?.account_status === "trial_expired") {
      navigate("/account-on-hold?status=trial_expired");
      return;
    }
  }

  function makePayment() {
    const user = utils.user(store);
    if (store && user && user?.email && user?.plan_id) {
      // setIsLoading(true);
      utils.onPaymentAuthURLCreateAndOpen(
        store,
        {
          user_id: user?.id,
          first_name: user?.name,
          last_name: user?.surname,
          email: user?.email,
          plan_id: user?.plan_id,
          type: "plan_payment"
        },
        setError
      );
      // setIsLoading(false);
    }
  }

  function isRentaleaseDomain() {
    return window.location.hostname.includes("rentalease.co.za");
  }

  /* -------------------------------- */
  /* RENDER METHODS */
  /* -------------------------------- */

  function renderPaymentDue() {
    return (
      <div className="flex flex-row justify-center items-center rounded text-black-700 space-x-2 text-center">
        <div className="flex">
          {/*<Icon size="lg" className="pb-1 px-2" name="fa-exclamation" />*/}
          <div>
            You have payment due on{" "}
            <b>{humanFormatDateWithDay(userDetails?.last_payment_end_date)}</b>, you can pay now.
          </div>
        </div>
        <div className="">
          <Button
            text="Pay now"
            onClick={() => {
              makePayment();
            }}
            noBold
          />
        </div>
      </div>
    );
  }

  function renderNewDomainBanner() {
    return (
      <div className="flex flex-row justify-center items-center rounded bg-blue-50 border border-blue-200 text-blue-800 space-x-2 text-center px-4 py-2">
        <div>
          We have a new domain! Visit us at{" "}
          <a
            href="https://rentalease.vertexease.com"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold underline hover:text-blue-600"
          >
            rentalease.vertexease.com
          </a>
        </div>
      </div>
    );
  }

  function render() {
    if (hide) {
      return null;
    }

    if (
      utils.isUserSuperAdminOrAdmin(store) ||
      utils.isFreePlan(store) ||
      utils.isUserTenant(store)
    ) {
      return isRentaleaseDomain() ? renderNewDomainBanner() : null;
    }

    return (
      <>
        {isRentaleaseDomain() && renderNewDomainBanner()}
        {error &&
          utils.generateErrorMessage({
            message: error
          })}
        {userDetails?.account_status === "pending" && renderPaymentDue()}
        {/*{invoice?.account_status === "on_hold" && renderPaymentOverDue()}*/}
      </>
    );
  }

  return render();
}

export default AccountBanner;
